<template>
  <div>
    <div v-if="userHasNotPaiedRecord">
      <span class="info el-icon-star-on" id="info1">您有一笔交易未完成 : </span>
      <span class="info" id="info2"
        ><span style="cursor: pointer;" type="success" @click="goRepayLastLogFun"
          >继续付款</span></span>
      <span class="info" id="info3"
        ><span style="cursor: pointer;" type="danger" @click="removeAllUnpaiedTradesFun"
          >取消这笔交易</span></span>
    </div>
  </div>
</template>

<script>
export default {
  emits: ['nextStepEvent'],
  props: {
    reCheckUnpaiedState: Boolean
  },
  mounted () {
    this.checkUnpaiedFun()
  },
  data () {
    return {
      userHasNotPaiedRecord: false,
      unpaiedShoppingCartId: 0
    }
  },
  methods: {
    checkUnpaiedFun () {
      // 查看用户之前是否曾选择过购物车但并未购买
      const api = '/md/front/shopping/cart/hasUnpaidLogBefore'
      this.axios.post(api).then(res => {
        if (res.status === 200 && res.data) {
          // 之前有未付款的缴费记录
          this.unpaiedShoppingCartId = parseInt(res.data)
          // alert('找到之前未付款的一个记录')
          this.userHasNotPaiedRecord = true
        }
      })
    },
    removeAllUnpaiedTradesFun () {
      const api = '/md/front/shopping/cart/clearUnpaidLog'
      this.axios.post(api).then(res => {
        if (res.status === 200) {
          this.userHasNotPaiedRecord = false
        }
      })
    },
    goRepayLastLogFun () {
      this.$emit('nextStepEvent', this.unpaiedShoppingCartId)
    }
  },
  watch: {
    // 当用户购买成功后同时点击上一步上一步返回回来, 这时需要重新检查当前的交易是否已经生效了
    reCheckUnpaiedState (v) {
      this.checkUnpaiedFun()
    }
  }
}
</script>

<style scoped>
.info {
  display: inline-block;
}
#info1 {
  color: #fff;
  font-size: 20px;
}

#info2 {
  margin-left: 40px;
  font-size: 16px;
}

#info3 {
  margin-left: 40px;
  font-size: 16px;
}
</style>
